module.exports = __webpack_public_path__ + "static/media/6.37b9ef34.jpg";